import React, { useMemo } from 'react';
import { ROUTE_NAMES } from '../../Routes/Routes';
import {
  ImageList,
  ImageListItem,
  makeStyles,
  useMediaQuery
} from '@material-ui/core';
import ImageButton from '../../Components/Buttons/ImageButton';
import { history } from '../../Routes/history';

// * ICONS

import DuplicatesIconButton from '../../Components/CustomIcons/IcDuplicatesButton';
import InvoiceIconButton from '../../Components/CustomIcons/IcButtonMyInvoices';
import PaymentsIcon from '../../Components/CustomIcons/PaymentsIcon';
import DebtsStatusIcon from '../../Components/CustomIcons/DebtsStatusIcon';
import SubrogationRequestIcon from '../../Components/CustomIcons/SubrogationRequestIcon';
import ConstructorsContactMeIcon from '../../Components/CustomIcons/ConstructorsContactMeIcon';
import { ConstructorRequestType } from '../../Enums/constructors';
import ConstructorsAdditionalJobIcon from '../../Components/CustomIcons/ConstructorsAdditionalJobIcon';

const ConstructorOptions = ({
  contractId,
  onOpenContactMeDialog,
  constructorInfo,
  className
}) => {
  const classes = useStyles();
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));
  const isSmallSize = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const deviceColumns = useMemo(() => {
    if (isMobileSize) {
      return 2;
    }
    if (isSmallSize) {
      return 3;
    }
    return 4;
  }, [isMobileSize, isSmallSize]);

  return (
    <ImageList
      rowHeight="auto"
      gap={16}
      cols={deviceColumns}
      className={className}
    >
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_payments"
          icon={PaymentsIcon}
          title="Pagos"
          aria-label="Pagos"
          onClick={() =>
            history.push(ROUTE_NAMES.payments, {
              type: 'contract',
              value: contractId
            })
          }
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_coupons"
          icon={DuplicatesIconButton}
          title="Mis cupones"
          aria-label="Mis cupones"
          onClick={() =>
            history.push(`${ROUTE_NAMES.transactions}?contract=${contractId}`, {
              disableContract: true
            })
          }
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_invoices"
          icon={InvoiceIconButton}
          title="Mis facturas"
          aria-label="Mis facturas"
          onClick={() =>
            history.push(`${ROUTE_NAMES.constructorInvoices}/${contractId}`)
          }
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_contact_me"
          icon={ConstructorsContactMeIcon}
          title="Quiero que me contacten"
          aria-label="Quiero que me contacten"
          onClick={onOpenContactMeDialog}
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_subrogation_request"
          icon={SubrogationRequestIcon}
          title="Solicitud de subrogación"
          aria-label="Solicitar subrogación"
          disabled={!constructorInfo}
          onClick={() =>
            history.push(
              `${ROUTE_NAMES.constructorRequest}/${ConstructorRequestType.Subrogation}/${contractId}`,
              { displayBreadcrumb: true, constructorInfo }
            )
          }
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_billing"
          icon={DebtsStatusIcon}
          title="Estado de cartera"
          aria-label="Estado de cartera"
          onClick={() =>
            history.push(`${ROUTE_NAMES.debtStatus}/${contractId}`)
          }
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="constructors_button_additional_job"
          icon={ConstructorsAdditionalJobIcon}
          title="Adicional de obra"
          aria-label="Adicional de obra"
          disabled={!constructorInfo}
          onClick={() =>
            history.push(
              `${ROUTE_NAMES.constructorRequest}/${ConstructorRequestType.AditionalJob}/${contractId}`,
              { displayBreadcrumb: true, constructorInfo }
            )
          }
        />
      </ImageListItem>
    </ImageList>
  );
};

const useStyles = makeStyles(theme => ({
  optionTile: {
    display: 'flex',
    width: '100%',
    height: '100%',
    paddingTop: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'start'
  }
}));

export default ConstructorOptions;
